import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
// import { DateEpochStorageTranscoder } from 'ngx-webstorage-service';
// import { LoginService } from '../../login-service';

// import { MessageService,Message } from '../../message.service';
import Swal from 'sweetalert2';
import { ImageuploadService } from '../../../Imageupload.service';
import { LoginService } from '../../../login-service';
// import { ImageuploadService } from '../../Imageupload.service';
@Component({
  selector: 'app-messages',
  templateUrl: './messages.component.html',
  styleUrls: ['./messages.component.scss'],
  providers:[LoginService]
})
export class MessagesComponent implements OnInit {
  url:any;
  tempGroupMessages:any;
  tempChatGroups:any;
  chatMessagesByGroups:any;
  IsGroup:boolean=false;
  userNames:any;
  userName:string;
  messageid:string;
  ReceiveruserID:string;
  // messages: Array<Message>;
  CollaboName:string;
  user: string;
  message: string;
  chatRoomsByUsers:any;
  chatMessagesByUsers:any;
ChatID:string;
  tempChatRooms:any;
  tempChatMessages:any;
  senderUserID:string;
displayChat:boolean=true;

 usersList:any;
  collaboratorsList=[];

  usersCol:any
  displayCollaborators:boolean= false;
  newGroup: boolean= false;
  groupName:any;
  selectedList:any;
  tempPraposalBids:any;
  collabarators:any;
  searchText:string;
  tempgrpByUsers=[];
  tempchatRoomByUsers:any;
  savedgname:boolean=false;
  userID:any;
  groupID: any;
  chatGrouplist: any;
  chatuserGrouplist: any;
  activeChatboxlist: any;
  ischatboxactive: boolean=false;
  ridlist: any;
  IsMessage:boolean=false;
  collabosList:any;
  tempCollabos:any;
  collaboID:string;
  groupUsersList: any;
  groupUsers: any=[];
  viewgrpInfo:boolean=false;
  groupsInCommon: any;
  CommongroupNames: any=[];
  viewchatinfo:boolean=false;
  tabType: string;
  tempUsersList: any;
  IsProfilePic: boolean;
  userspic: any=[];
  imagefile: void;
  ProfilePic: any;
  lastmessage: any=[];
  addNewuser:boolean=false;
  userTypeName:string;
  addparticipantList=[];
  constructor(
    // private messageService: MessageService,
    public imageservice: ImageuploadService,private loginService:LoginService,private router:Router,private activateRoute:ActivatedRoute,
  ) {
    this.senderUserID=localStorage.getItem('USERID');
    this.ReceiveruserID = this.activateRoute.snapshot.params['userID'];
    // this.messages = [];
    this.ChatID = this.activateRoute.snapshot.params['chatid'];
    this.collaboID=this.activateRoute.snapshot.params['collaboid'];
    this.userTypeName=localStorage.getItem("userType");
  }

  ngOnInit() {
  
  this.url=this.loginService.imageURL;
this.GetUsers();
    this.GetChatRooms();

    this.GetPraposalBids();
    this.GetChatMessages();
    this.GetCollabos();
    
      this.userID=localStorage.getItem('USERID');
      this.Getchatgroup();
      this.Getchatusergroup();
      this.loginService.GetChatRooms().subscribe(data=>{
        data = JSON.parse(data['_body']);
        this.tempChatRooms=JSON.parse(JSON.stringify(data));
      
      let filterChats=this.tempChatRooms.filter(x=>x.chatid==this.ChatID);
     
      if(filterChats.length>0)
{
this.UserDetails(filterChats[0],'');
}
else
{
  if(this.ReceiveruserID!==this.senderUserID){
    this.ChatID='';
    const json={
      chatid:this.ChatID,
      userid:this.userID,
      createdbyparam:'admin',
      updatedbyparam:'admin',
      collaboid:this.collaboID,
      receiveruserid:this.ReceiveruserID
    }
    this.loginService.SaveChatRoomByUserID(json).subscribe(data=>{
    
      this.cancel();
      this.GetChatRooms();
    })
  }

  }
      
      });
  }

  //group pic trigger method
  openclick(event:any)
  {
   event.preventDefault();
   let element:HTMLElement=document.getElementById('uploadpic') as HTMLElement;
   element.click();
  }

  //group pic upload method
  fileChange1(input,param) {
    this.imagefile = this.loginService.filechange1(input, param,this.activeChatboxlist.id);
    this.imageservice.ImageUplode1.subscribe(Img => this.ProfilePic = Img);
   
    this.GetUsers();
      this.Getchatgroup();
      this.Getchatusergroup();
    this.GetChatRooms();

  }

  Searchtext(){
    this.tempgrpByUsers=[];
    this.tempchatRoomByUsers=[];
this.FilterGroupsByUsers();
this.FilterChatByUsers();
  }
  FilterGroupsByUsers(){
   this.tempgrpByUsers = this.chatGrouplist;

 let tempCompany = this.chatGrouplist.filter(
   (item) => {
     return (
       (item.name !== null && item.name.toLowerCase().indexOf(this.searchText.toLowerCase().trim()) > -1)
     );
   }

 );
 this.tempgrpByUsers = tempCompany;

  }
  FilterChatByUsers(){
   this.tempchatRoomByUsers = this.chatRoomsByUsers;
 
       let tempCompany = this.chatRoomsByUsers.filter(
         (item) => {
           return (
             (item.user_name !== null && item.user_name.toLowerCase().indexOf(this.searchText.toLowerCase().trim()) > -1)||
             (item.user_name1 !== null && item.user_name1.toLowerCase().indexOf(this.searchText.toLowerCase().trim()) > -1)
           );
         }
   
       );
       this.tempchatRoomByUsers = tempCompany;
      
  }



GetCollabos(){
  this.loginService.GetCollabos(this.userTypeName).subscribe(data=>
    {
      data = JSON.parse(data['_body']);

      this.tempCollabos=JSON.parse(JSON.stringify(data));

      let filterCollabos=this.tempCollabos.filter(x=>x.userid.toString()==this.senderUserID.toString());
      if(filterCollabos.length>0){
        this.collabosList=filterCollabos;
       
        let filterCNames=this.collabosList.filter(x=>x.id==this.collaboID);
if(filterCNames.length>0)
{
  this.CollaboName=filterCNames[0].name;
}
else{
  this.CollaboName="";
}

      }
      else{
        this.collabosList=[];
      }
    
    })
}
calculateDiff(sentDate,enddate) {
  var date1:any = new Date(sentDate);
  var date2:any = new Date(enddate);
  var diffDays:any = Math.floor((date2 - date1) / (1000 * 60 * 60 * 24));

  return diffDays;
}
GetUsers(){
    this.loginService.GetUsers(this.userTypeName).subscribe(data=>{
      data = JSON.parse(data['_body']);
      this.tempUsersList=JSON.parse(JSON.stringify(data));
      let filterUser=this.tempUsersList.filter(x=>x.id.toString()==this.userID.toString());
      if(filterUser.length>0){
        this.usersList=filterUser[0];
       
      }
      
    })
    }
  GetChatRooms(){
    
    this.chatRoomsByUsers=[];
    this.chatMessagesByUsers=[];
    this.tempChatMessages=[];
    this.tempChatRooms=[];
    this.loginService.GetChatRooms().subscribe(data=>{
      data = JSON.parse(data['_body']);
      this.tempChatRooms=JSON.parse(JSON.stringify(data));
console.log(this.tempChatRooms)
let filterchtroom=this.tempChatRooms.filter(x=>x.collaboid.toString()==this.collaboID.toString());
console.log(filterchtroom)
      if(filterchtroom.length>0){
        this.chatRoomsByUsers=filterchtroom;
        this.tempchatRoomByUsers=filterchtroom;
      }
      else{
        this.chatRoomsByUsers=[];
        this.tempchatRoomByUsers=[];
      }
      console.log(this.tempchatRoomByUsers)
    
      this.loginService.GetChatMessages().subscribe(data=>{
        data = JSON.parse(data['_body']);
        this.tempChatMessages=JSON.parse(JSON.stringify(data));
      
      for(let i=0;i<this.tempchatRoomByUsers.length;i++){
      let filterMessages=this.tempChatMessages.filter(x=>x.chatid.toString()==this.tempchatRoomByUsers[i].chatid.toString() );
      var length1=filterMessages.length-1;
     
      this.lastmessage.push(filterMessages[length1].message);
      }
    });

      this.loginService.GetChatMessages().subscribe(data=>{
        data = JSON.parse(data['_body']);
        this.tempChatMessages=JSON.parse(JSON.stringify(data));

let filterChatMsg=this.tempChatMessages.filter(x=>x.chatid==this.ChatID);

if(filterChatMsg.length>0){
  this.chatMessagesByUsers=filterChatMsg;
}
 else{
   this.chatMessagesByUsers=[];
 }

      })
    })
  }

  groupInfo(g){
    this.addNewuser=false;
    console.log("this")
    this.groupUsers=[];
   
    this.Getchatusergroup();
    this.viewgrpInfo=true;
    
    this.groupUsersList=this.chatuserGrouplist.filter(x=>x.groupid==g.id);
    
    for(var i=0;i<this.groupUsersList.length;i++){
      this.groupUsers.push(this.tempUsersList.filter(x=>x.id==this.groupUsersList[i].userid));
     
    }
  console.log(this.groupUsers)
  }
  cancelgrpinfo(){
    this.viewgrpInfo=false;
    this.addNewuser=false;
  }

  DisplayChatInfo(row){
    this.CommongroupNames=[];
    
    this.viewchatinfo=true;
  
    this.groupsInCommon=this.chatuserGrouplist.filter(x=>x.userid==row.receiveruserid && x.createdby==this.senderUserID)
  
    for(var i=0;i<this.groupsInCommon.length;i++){
      let groupNames;
    groupNames=this.chatGrouplist.filter(x=>x.id==this.groupsInCommon[i].groupid && x.collaboid==row.collaboid);
    if(groupNames.length>0){
      this.CommongroupNames.push(groupNames);
    }
    
  }
  
  }
  cancelchatinfo(){
    this.viewchatinfo=false;
  }
  
  GetChatMessages(){
    this.loginService.GetChatMessages().subscribe(data=>{
      data = JSON.parse(data['_body']);
      this.tempChatMessages=JSON.parse(JSON.stringify(data));
    this.tempGroupMessages=JSON.parse(JSON.stringify(data));

    })
  }
  newMessage(text: string, user: string): void {

    
   this.message = '';
  }
  SaveMessages(row){
    
    this.groupID=row.id;
    
if(this.IsGroup){
  this.ChatID='0';
  
  const json={
    chatid:this.ChatID,
  message:this.message,
  groupid:this.groupID,
  senderuserid:this.senderUserID,
  receiveruserid:this.senderUserID,
  createdbyparam:'Admin',
  updatedbyparam:'Admin',
  IsSender:1
  }
  
  this.loginService.SaveChatMessages(json).subscribe(data=>{
    
    this.groupID="0"
   
    this.message="";
    this.GetChatMessages();
    this.openChatbox(row);

    this.message="";
  
  })
// }
}
else{
  this.groupID='0';

const json={
  chatid:this.ChatID,
message:this.message,
groupid:this.groupID,
senderuserid:this.senderUserID,
receiveruserid:this.ReceiveruserID,
createdbyparam:'Admin',
updatedbyparam:'Admin',
IsSender:1
}

this.loginService.SaveChatMessages(json).subscribe(data=>{

  this.ChatID="0";

  this.message="";
  this.GetChatMessages();
 this.UserDetails(row,'');
 this.GetChatRooms();

  this.message="";

})
}
this.sendNotification(this.message);
this.GetChatMessages();
  }
  sendNotification(message:string){
    const json={
      id:0,
    name:'New Message',
    description:message,
    userid:this.userID,
    receiveruserid:this.ReceiveruserID,
    type:'message',
    typeid:0,
    createdby:'Admin',
    updatedby:'Admin',
    IsSender:0
    }
   
    this.loginService.SaveNotifications(json).subscribe(data=>{
  
    });
  
  }
  BackCollabo(){
    
    if(this.ChatID=='0'){
      this.router.navigate(['/initatorhead/initatormessage']);
      
     
    }
    else{
      this.router.navigate(['/initatorhead/initatormessage']);
      
    }
  }
  
UserDetails(row,g){
  this.tabType='ichat';
  this.userNames="";
  this.userNames=row;
 
  this.ChatID=row.chatid;
  this.viewchatinfo=false;
  
  let filterchats=this.chatRoomsByUsers.filter(x=>x.chatid===row.chatid);
  this.userNames=filterchats;
  
  this.loginService.GetChatMessages().subscribe(data=>{
    data = JSON.parse(data['_body']);
    this.tempChatMessages=JSON.parse(JSON.stringify(data));
  this.tempGroupMessages=JSON.parse(JSON.stringify(data));

  //this.GetChatRooms();
  this.ischatboxactive=true;
  this.IsGroup=false;
this.newGroup=false;
  this.displayCollaborators=false;
  this.displayChat=true;
    
    this.ReceiveruserID=row.receiveruserid;
    this.ChatID=row.chatid;

    let filterMessages=this.tempChatMessages.filter(x=>x.chatid.toString()==row.chatid.toString() );
    
    if(filterMessages.length>0){
        this.chatMessagesByUsers=filterMessages;
    }
    else{
       this.chatMessagesByUsers=[];
    }
   
  });
   
}

GetPraposalBids(){
  this.tempPraposalBids=[];
  this.loginService.GetPraposalBids().subscribe(data=>{
    data = JSON.parse(data['_body']);
    this.tempPraposalBids=JSON.parse(JSON.stringify(data));
  })
}
  sendNewmessage(){

this.GetPraposalCollabarators();

this.displayCollaborators=true;
this.newGroup=false;
this.savedgname=false;
this.IsGroup=false;
this.ischatboxactive=false;
  }
  SelectColabarator(row){
    let filterChatRooms=this.chatRoomsByUsers.filter(x=>x.userid.toString()==this.userID.toString() && x.receiveruserid==row.receiverid);
   
if(filterChatRooms.length>0)
{
this.UserDetails(filterChatRooms[0],'');
}
else
{

    const json={
      chatid:this.ChatID,
      userid:this.userID,
      createdbyparam:'admin',
      updatedbyparam:'admin',
      collaboid:row.collaboid,
      receiveruserid:row.receiverid
    }
    this.loginService.SaveChatRoomByUserID(json).subscribe(data=>{
    
      this.cancel();
      this.GetChatRooms();
    })
  }
  }

  GetPraposalCollabarators(){
    this.usersCol=[];
this.collaboratorsList=[];
this.collabarators=[];
this.usersCol=this.tempUsersList.filter(x=>x.user_type==="Collaborator");

let filterCollabos=this.tempPraposalBids.filter(x=>x.collaboid.toString()==this.collaboID.toString());

if(filterCollabos.length>0){
 this.collabarators=filterCollabos;
}
for(let i=0;i<this.collabarators.length;i++){

  let filterColUsers=this.usersCol.filter(x=>x.id===this.collabarators[i].userid);

if(filterColUsers.length>0)
{

  
  this.collaboratorsList.push({
    collaboid:this.collabarators[i].collaboid,
    receiverid:this.collabarators[i].userid,
    senderid:this.senderUserID,
    user_name:filterColUsers[0].user_name,
    Profile:filterColUsers[0].Profile
  });

}

}
  }
  Newgroup(){
    this.GetPraposalCollabarators();
   
    this.newGroup=true;
    this.IsGroup=false;
    this.displayChat=false;
    this.displayCollaborators=false;
    this.ischatboxactive=false;
    
    
  }
  getSelectedcolrs(){

  }
  SaveGroupname(){
 
    if(this.groupName===''||this.groupName===undefined){
      return;
    }else{
    const json={
      name:this.groupName,
      createdby:'Admin',
      userid:this.userID,
      collaboid:this.collaboID
    }
    this.loginService.InsertchatGroup(json).subscribe(data=>{
      
      this.groupID=data['_body'].toString();
      this.Getchatgroup();
    }
    );
    this.savedgname=true;
  }
  
  }
  removeUser(udetails,gdetails){
  
    this.Getchatusergroup();
let filteredid=this.chatuserGrouplist.filter(x=>x.groupid==gdetails.id && x.userid==udetails.id)

event.stopPropagation();
  Swal.fire({
    title: 'Are you sure?',
    text: 'You want to remove this user:' + udetails.user_name,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Yes',
    cancelButtonText: 'No'
  }).then((result) => {
    if (result.value) {
      this.deleteuser(filteredid[0].id,gdetails);
    } else if (result.dismiss === Swal.DismissReason.cancel) {

    }
  })

}

deleteuser(ID,g) {
  const json={
    id:ID
  }
  this.loginService.DeletechatuserGroup(json).subscribe(data => {
    
     Swal.fire("User removed successfully")
    setTimeout(() => {
      this.message = "";
    }, 1000);
  // this.Getchatusergroup();
  this.groupInfo(g);
  })

  }


  deleteGroup(g){

event.stopPropagation();
  Swal.fire({
    title: 'Are you sure?',
    text: 'You want to delete this group:'+g.name,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Yes',
    cancelButtonText: 'No'
  }).then((result) => {
    if (result.value) {
       this.deletegrp(g.id);
    } else if (result.dismiss === Swal.DismissReason.cancel) {

    }
  })

}

deletegrp(ID) {
  const json={
    id:ID
  }
  this.loginService.DeletechatGroup(json).subscribe(data => {
    
     Swal.fire("Group deleted successfully")
    setTimeout(() => {
      this.message = "";
    }, 1000);
  this.Getchatgroup();
  // this.groupInfo(g);
  })

  }
  
  Addnewuser(){
    this.addparticipantList=[];
    this.addNewuser=true;
    this.selectedList=''
    this.GetPraposalCollabarators();
    var array=[];
    console.log(this.collaboratorsList)
    console.log(this.groupUsers)
    for(var i=0;i<this.collaboratorsList.length;i++){
      array=this.groupUsers.filter(x=>x[0].id==this.collaboratorsList[i].receiverid)
    // array=this.collaboratorsList.filter(x=>x.receiverid==this.groupUsers[i][0].id)
    console.log(array)
    if(array.length>0){
      array=[]
    }
    else{
      this.addparticipantList.push({
        Profile: this.collaboratorsList[i].Profile,
        collaboid: this.collaboratorsList[i].collaboid,
        receiverid: this.collaboratorsList[i].receiverid,
        senderid: this.collaboratorsList[i].senderid,
        user_name: this.collaboratorsList[i].user_name,
         })
    }
    console.log(this.addparticipantList)
   
  }
    
  }
  SavenewUsers(g){
   
    if(this.selectedList.length!==0){
      for (var i=0;i<this.selectedList.length;i++){
      const json={
        createdby:this.userID,
        groupid:g.id,
        userid:this.selectedList[i]
      }
     
      this.loginService.InsertchatuserGroup(json).subscribe(data=>{
     
       this.Getchatusergroup();
       Swal.fire("Users added successfully");
       this.addNewuser=false;
      
       this.groupInfo(g);
       this.openChatbox(this.activeChatboxlist);
      }
      );
    }
    }
  }
  SavegroupUsers(){
    if(this.selectedList.length!==0){
      for (var i=0;i<this.selectedList.length;i++){
      const json={
        createdby:this.userID,
        groupid:this.groupID,
        userid:this.selectedList[i]
      }
   
      this.loginService.InsertchatuserGroup(json).subscribe(data=>{
      
       this.Getchatusergroup();
       Swal.fire("Group created successfully");
       this.cancel();
      }
      );
    }
    }
    else{
      return;
    }

  }
  Getchatgroup(){
    this.loginService.GetchatGroup().subscribe(data=>{
       data = JSON.parse(data['_body']);
       this.tempChatGroups=JSON.parse(JSON.stringify(data));
        
let filterChats=this.tempChatGroups.filter(x=>x.collaboid==this.collaboID);
 this.chatGrouplist=filterChats;
 this.tempgrpByUsers=this.chatGrouplist;

this.url=this.loginService.imageURL;
    })
}
Getchatusergroup(){
  this.loginService.GetchatuserGroup().subscribe(data=>{
     data = JSON.parse(data['_body']);
     
     this.chatuserGrouplist=JSON.parse(JSON.stringify(data));
     
  })
}
openChatbox(g){
  this.Getchatgroup();

  this.tabType='gchat';
  this.loginService.GetChatMessages().subscribe(data=>{
    data = JSON.parse(data['_body']);
    this.tempChatMessages=JSON.parse(JSON.stringify(data));
  this.tempGroupMessages=JSON.parse(JSON.stringify(data));

this.displayChat=false;
  this.chatMessagesByGroups=[];
  this.viewgrpInfo=false;
  this.groupID=g.id;
  this.IsGroup=true;
  this.newGroup=false;
  this.activeChatboxlist=g;
  this.ischatboxactive=false;
  this.displayCollaborators=false;
  this.chatMessagesByUsers=[];

  let chatMessages=this.tempChatMessages.filter(x=>x.groupid==this.groupID );
  
if(chatMessages.length>0){
  this.chatMessagesByGroups=chatMessages;
}
else{
  this.chatMessagesByGroups=[];
}
  
  });
  
}
  cancel(){
    this.displayCollaborators=false;
    this.newGroup=false;
    this.savedgname=false;
    this.displayChat=true;
  }}
